import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  notifications = [
    {
      "id": 0,
      "timestamp": "2024-04-11T10:43:38.853Z",
      "notificationTo": "string",
      "destination": "https://example.com",
      "notificationFrom": "string",
      "message": "Example notification message",
      "expenseId": 0,
      "isRead": true,
      "isArchived": true
    },
    {
      "id": 0,
      "timestamp": "2024-04-11T10:43:38.853Z",
      "notificationTo": "string",
      "destination": "https://example.com",
      "notificationFrom": "string",
      "message": "Example notification message",
      "expenseId": 0,
      "isRead": false,
      "isArchived": true
    }
    // Add more notifications as needed
  ];

  apiForNotifications = environment.apiToGetAllNotification + '/notifications';

  constructor(private http: HttpClient) { }

  // getNotifications() {
  //   return this.notifications;
  // }

  getNotifications(status: string): Observable<any>{
    return this.http.get(status ? this.apiForNotifications + '?readStatus='+status : this.apiForNotifications,{
      headers: { 'content-type': 'application/json' }
    });
  }

  markAsRead(notificationId: number): Observable<any> {
    return this.http.patch(this.apiForNotifications + '/' + notificationId + '/mark-as-read',{
      headers: { 'content-type': 'application/json' }
    });
  }

  markAllAsRead(): Observable<any> {
    return this.http.patch(this.apiForNotifications + '/mark-all-as-read',{
      headers: { 'content-type': 'application/json' }
    });
  }

}
